
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"-6 0 34 26","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-calculator)"}},[_c('path',{attrs:{"d":"M12.713 12.713V24H24V12.713H12.713zm8.844 7.545h-6.401v-1.426h6.401v1.426zm0-2.377h-6.401v-1.425h6.401v1.425zM0 12.713V24h11.287V12.713H0zm8.41 7.403l-1.007 1.008-1.76-1.76-1.759 1.76-1.008-1.008 1.76-1.76-1.76-1.759 1.008-1.008 1.76 1.76 1.759-1.76 1.008 1.008-1.76 1.76 1.76 1.759zM12.713 0v11.287H24V0H12.713zm2.443 6.356V4.931h6.401v1.425h-6.401zM0 0v11.287h11.287V0H0zm8.844 6.356H6.356v2.488H4.931V6.356H2.443V4.931H4.93V2.443h1.425V4.93h2.488v1.425z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-calculator"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    